<script>
  import {
    XIcon,
  } from 'vue-feather-icons'

  export default {
    components: {
      XIcon,
    },
    props: {
      isExternal: {
        type: Boolean,
        default: false,
      },
      references:{
        type: Object,
        required: true,
      },
      referenceKey:{
        type: String,
        required: true,
      }
    },
    data() {
      return {
        windowWidth: 0,
      }
    },
    computed: {
      isMobile(){
        return this.windowWidth < 768
      },
      isTablet(){
        return this.windowWidth < 1024
      },
      hasWarningShown(){
        if (this.$store && this.$store.state && this.$store.state.tab && Object.prototype.hasOwnProperty.call(this.$store.state.tab, 'showWarning')){
          return this.$store.state.tab.showWarning
        }
        return false
      },
    },
    async created() {
      this.windowWidth = window.innerWidth
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      });
    },
  }
</script>

<template>
  <div
    id="search-id-unique"
    class="
      filters-panel
      tw-h-[70%]
      !tw-overflow-y-scroll lg:!tw-overflow-y-hidden
      scroll-primary-sm scroll-pr-1 scroll-py-2 scroll-square scroll-ios-pr-2.5
      tw-inline-block
      tw-mr-[-1.3rem]"
    :class="{
      'filters-panel-ext': isExternal,
      '!tw-mr-[-1.3rem]': !isExternal,
      'tw-fixed tw-right-4 tw-top-28 fade': isTablet,
      'tw-top-48': hasWarningShown,
    }">
    <slot />
    <section
      class="tw-flex lg:tw-hidden tw-h-10 tw-items-center tw-justify-end tw-cursor-pointer tw-text-primary"
      @click="references[referenceKey].toggleSearch(false)">
      <span class="tw-mr-6 tw-flex tw-items-center">Close Filters <XIcon size="2x" class="tw-pl-2"/></span>
    </section>
  </div>
</template>
